import { render } from "./TaskStatusLabel.vue?vue&type=template&id=593e5ed2&scoped=true"
import script from "./TaskStatusLabel.vue?vue&type=script&lang=js"
export * from "./TaskStatusLabel.vue?vue&type=script&lang=js"

import "./TaskStatusLabel.vue?vue&type=style&index=0&id=593e5ed2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-593e5ed2"

export default script